import { Brand, createBranded } from '@deltasierra/type-utilities';

export type AssetsBuilderTemplatesPublishedArtifactsId = Brand<number, 'AssetsBuilderTemplatesPublishedArtifactsId'>;
export const AssetsBuilderTemplatesPublishedArtifactsId = createBranded<AssetsBuilderTemplatesPublishedArtifactsId>();
